

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ITypedIdWithName } from '../../../httpClient/serverApi/types/ITypedId';
import { IGroup } from '../../../userManagement/groups/serverApi/types/IGroup';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { ITypedIds } from '../../types/ITypedIds';
import { IAuthorizableGranteePermissions } from '../types/IAuthorizableGranteePermissions';

export interface IGetExplicitPermissionsParams {
  authorizables: ITypedIds;
}

export interface ISourceAuthorizable extends ITypedIdWithName {
  controllingPermissionsEnabled: boolean;
}

export interface IUserPermissionable extends IUser {
  disallowProjectLeader?: boolean;
}

export interface IGroupSetWebClientModel {
  id: string; // localId
  groupSetLuid: string;
  name: string;
  groupCount: number;
}

export interface IGetExplicitPermissionsResult extends IResult {
  permissions: IAuthorizableGranteePermissions[];
  groups: IGroup[];
  users: IUserPermissionable[];
  groupSets: IGroupSetWebClientModel[];
  sourceAuthorizableById?: _.Dictionary<ISourceAuthorizable>;
}

export class GetExplicitPermissionsRequest extends Request<IGetExplicitPermissionsParams, IGetExplicitPermissionsResult> {
  constructor(params: IGetExplicitPermissionsParams) {
    super('getExplicitPermissions', params);
  }
}

export class GetExplicitPermissionsProjectsRequest extends Request<IGetExplicitPermissionsParams, IGetExplicitPermissionsResult> {
  constructor(params: IGetExplicitPermissionsParams) {
    super('getProjectExplicitPermissions', params);
  }
}
